/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 29/3/2023
 */


import { Button, IconButton, ImageList, ImageListItem, ImageListItemBar } from "@mui/material";
import { HighlightOff } from "@mui/icons-material";

import styles from "./ImageUploader.module.css"
import { useDeleteImageMutation, useUploadCategoryImageMutation, useUploadImagesMutation } from "../../Store/Services/ImageService";

const ImageUploader = (props) => {

  const {images, setImages, from, id } = props;

  const [uploadImage] = useUploadImagesMutation();
  const [uploadCatImage] = useUploadCategoryImageMutation();
  const [deleteImage] = useDeleteImageMutation();

  const onImageUpload = async (e) => {
    var data = new FormData();

    for (var i=0; i< e.target.files.length; i++){
      console.log(e.target.files[i]);
      var imagedata = e.target.files[i]
      data.append("images", imagedata);
    }

    if(from==="editItem" || from==="editCat"){
      data.append("folder", `${id}`)
    }

    console.log('from', from);

    if ( from === 'item' || from === 'editItem') {
      try {
        const result = await uploadImage(data).unwrap();
        console.log('item result', result);
        setImages([...images, ...result[0].imageList])
      } catch (err) {
          console.error(err);
      }
    } else if ( from === 'cat' || from === 'editCat') {
      try {
        const result = await uploadCatImage(data).unwrap();
        console.log('cat result', result);
        setImages([...images, ...result[0].imageList])
      } catch (err) {
          console.error('cat image uploader error', err);
      }
    }
  }
  // console.log(images)

  const handleDeleteImage = async (e) => {
    try {
      const result = await deleteImage(e).unwrap();
      console.log('result', result);
      if(result.length===0){
        const s = images.filter((item) => item !== e);
        setImages(s);
      }
    } catch (err) {
        console.error(err);
    }
  };

  return (
    <div className={styles.container}>
      <ImageList className={styles.imgList} gap={5} cols={4} rowHeight={110}>
        {images?.length !== 0 &&
          images?.map((img, index) => (
          <div key={index} className={styles.itemContainer}>
          <ImageListItem>
            <img src={`${process.env.REACT_APP_IMAGE_URL}${img}`} alt="" className={styles.image} />
            {from === "view" ? null :
              <ImageListItemBar
                className={styles.imageBar}
                position="top"
                actionIcon={
                  <IconButton
                    className={styles.closeIcon}
                    onClick={() => handleDeleteImage(img)}
                  >
                    <HighlightOff/>
                  </IconButton>
                }
                actionPosition="right"
              />
            }
          </ImageListItem>
          </div>
        ))}
      </ImageList>
      <div>
          <label htmlFor="contained-button-file">
            <div className={styles.buttonContainer}>
              {from === "view" ? null :
                <form encType="multipart/form-data">
                  <Button color="secondary" variant="contained" component="span">
                    Upload
                    <input
                      onChange={onImageUpload}
                      accept="image/*"
                      id="contained-button-file"
                      type="file"
                      hidden
                      multiple={!(from==="cat"||from==="editCat")}
                      disabled={(from==="cat"||from==="editCat")&&images.length>2}
                    />
                  </Button>
                </form>
              }
            </div>
          </label>
      </div>
    </div>
  );
}

export default ImageUploader;